// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"dc619f0842b0e01ca8af","966":"44ea0bb01ee08a0e0757"}[chunkId] + ".js";
};